<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllBudget()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                label="Issue No"
                name="issueNo"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                v-model="queryParams.financeSettingId"
                :items="financeSettingList"
                label="Choose Finance Setting ..."
                item-text="financialYearName"
                item-value="id"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                v-model="queryParams.shopId"
                :items="shopList"
                label="Choose Shop ..."
                item-text="name"
                item-value="id"
                menu-props="auto"
                :readonly="checkUserShop() ? true : false"
              ></v-select>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="budgetHeaderList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            must-sort
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>
                {{ props.item.issueDateInMilliSeconds | format-ms-date }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.financialYearName }}</td>
              <td>{{ props.item.totalBudgetAmount }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { budgetService } from "../../services/budget-service";
import { shopService } from "../../services/shop-service";
import { financeSettingService } from "../../services/finance-setting-service";
import { commonService } from "../../services/common-service";

export default {
  name: "BudgetList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    buttonLoading: false,
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Budget",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Shop", value: "shop.name" },
      { text: "Financial Year", value: "financeSetting.financialYearName" },
      { text: "Total Budget Amount", sortable: false },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totoalItems: 0,
    },
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      shopId: "",
      financeSettingId: "",
      isAddDetails: false,
    },
    totalRows: 0,
    budgetHeaderList: [],
    shopList: [],
    financeSettingList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getBudgetHeaderList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.financeSettingId) {
      this.queryParams.financeSettingId = this.$route.query.financeSettingId;
    }
    if (this.$route.query.isAddDetails) {
      this.queryParams.isAddDetails = this.$route.query.isAddDetails;
    }

    this.getAllShop();
    this.getFinanceSettingList();
    this.queryParams.shopId = this.checkUserShop();
  },
  methods: {
    checkUserShop() {
      if (this.user.role.roleName == "BRANCH_ADMIN") {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "budgets", query: this.queryParams });
      this.getBudgetHeaderList();
    },
    getFinanceSettingList() {
      financeSettingService
        .getAllFinanceSetting()
        .then((res) => {
          this.financeSettingList = res.data.financeSettingDTOs;
          this.financeSettingList.unshift({
            id: "",
            financialYearName: "----All----",
          });
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.response = err.response.data.message;
          }
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.unshift({ id: "", name: "----All----" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getBudgetHeaderList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      budgetService
        .getBudgetHeaderList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.budgetHeaderList = res.data.budgetHeaderList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    exportAllBudget() {
      this.buttonLoading = true;
      budgetService
        .getBudgetExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/budget/new");
    },
    onEdit(budget) {
      // go to details page
      this.$router.push("/budget/" + budget.id);
    },
  },
};
</script>
